import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSimpleButton from '@/components/AppSimpleButton.vue';
import { utcDateTimeToLocal } from '@/utils/dateTime';
import { showErrors, showNotification } from '@/utils/snack';
import AppTab from '@/components/AppTab.vue';
import DealerDialog from '../DealerList/script-dialog';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppAutoComplete from '@/components/AppAutoComplete.vue';
import AppFormItem from '@/components/AppFormItem.vue';
import { updateDealerSchools, assignGoodsToDealer, removeGoodsFromDealer } from './gql';
import { SnackType } from '@/interfaces/snack';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import { GoodsStatusText } from '@/helpers/goods';
import AppTextarea from '@/components/AppTextarea.vue';
import AuthFilter from '@/mixins/auth-filter';
import { GoodsOrderBy } from '@/interfaces/goods';
import DealerOrders from './script-orders';
import { findGoods } from '../GoodsList/gql';
import { formatCurrency } from '@/utils/currency';
Component.registerHooks(['beforeRouteLeave']);

var DealerDetail = /*#__PURE__*/function (_mixins) {
  _inherits(DealerDetail, _mixins);

  var _super = _createSuper(DealerDetail);

  function DealerDetail() {
    var _this;

    _classCallCheck(this, DealerDetail);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '经销商管理'
    }, {
      text: '经销商',
      to: {
        name: 'DealerList'
      }
    }];
    _this.formatCurrency = formatCurrency;
    _this.items = ['小店商品', '经营学校'];
    _this.activeTab = 0;
    _this.disableConfirm = false;
    _this.dealer = null;
    _this.targetSchool = null;
    _this.GoodsStatusText = GoodsStatusText;
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    _this.dealerId = '';
    _this.dealerName = '';
    _this.loading = false;
    _this.goodsLoading = false;
    _this.searchLoading = false;
    _this.schools = [];
    _this.goods = [];
    _this.headers = [{
      text: '学校名称',
      value: 'name',
      sortable: false,
      width: 300
    }, {
      text: '地区',
      value: 'area.mergerName',
      sortable: false
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.goodsHeaders = [{
      text: '封面',
      value: 'good.thumb',
      sortable: false
    }, {
      text: 'ISBN',
      value: 'good.isbn',
      sortable: false
    }, {
      text: '商品标题',
      value: 'good.title',
      sortable: false
    }, {
      text: '作者',
      value: 'good.author',
      sortable: false
    }, {
      text: '出版社',
      value: 'good.press',
      sortable: false
    }, {
      text: '本店价格',
      value: 'price',
      sortable: false
    }, {
      text: '佣金比例',
      value: 'sharingProportion',
      sortable: false
    }, {
      text: '状态',
      value: 'good.status',
      sortable: false
    }, {
      text: '顺序',
      value: 'order',
      sortable: false
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.searchHeaders = [{
      text: '封面',
      value: 'thumb',
      width: 80,
      sortable: false
    }, {
      text: '商品标题',
      width: 270,
      value: 'title',
      sortable: false
    }, {
      text: '价格',
      value: 'price',
      sortable: false
    }];
    _this.options = {
      itemsPerPage: 500
    };
    _this.goodsOptions = {
      itemsPerPage: 500,
      sortDesc: [true]
    };
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.addGoods = {
      title: '添加商品',
      show: false
    };
    _this.filter = {
      title: ''
    };
    _this.allGoods = [];
    _this.selectedGoods = [];
    _this.addManageSchoolDialog = {
      show: false,
      title: '添加学校'
    };
    _this.allSchools = [];
    _this.addManageSchoolForm = {
      area: null,
      filterSchools: [],
      selectedSchools: []
    };
    _this.deleteDealerSchoolsDialog = {
      show: false,
      text: ''
    };
    _this.deleteDealerGoodsDialog = {
      show: false,
      text: ''
    };
    return _this;
  }

  _createClass(DealerDetail, [{
    key: "goodRelationsChange",
    value: function goodRelationsChange(val) {
      if (val && val.length !== 0) {
        var goods = val.map(function (item) {
          if (!item.price) {
            item.price = item.good.price;
          }

          if (!item.details) {
            item.details = item.good.details;
          }

          return item;
        });
        var goodsArr = [];

        if (this.displayOrders.length !== 0) {
          this.displayOrders.forEach(function (id) {
            goods.forEach(function (item) {
              if (item.goodId === id) {
                goodsArr.push(item);
              }
            });
          });
          this.goods = goodsArr.map(function (item, index) {
            return _objectSpread({}, item, {
              order: index + 1
            });
          });
        }
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$targetDealer, _this$targetDealer2, _this$targetDealer3;

        var activeTab, id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.getRole() === 'dealer') {
                  this.goodsHeaders.pop();
                }

                this.onResize();
                activeTab = sessionStorage.getItem('activeTab');

                if (activeTab) {
                  this.activeTab = +activeTab;
                }

                _context.next = 6;
                return this.getGoodsOrders();

              case 6:
                if (this.getRole() === 'dealer') {
                  this.headers.pop();
                }

                id = this.$route.params.id;
                this.dealerId = id;
                _context.next = 11;
                return this.getDealerById(Number(this.dealerId));

              case 11:
                this.targetDealer = _context.sent;
                this.schools = (_this$targetDealer = this.targetDealer) === null || _this$targetDealer === void 0 ? void 0 : _this$targetDealer.schools;
                this.dealerId = ((_this$targetDealer2 = this.targetDealer) === null || _this$targetDealer2 === void 0 ? void 0 : _this$targetDealer2.id) + '';
                this.dealerName = ((_this$targetDealer3 = this.targetDealer) === null || _this$targetDealer3 === void 0 ? void 0 : _this$targetDealer3.realname) + '';
                this.breadcrumbs.push({
                  text: "".concat(this.dealerName)
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "deleteConfirm",
    value: function () {
      var _deleteConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.deleteDealerById();

              case 2:
                this.$router.push({
                  name: 'DealerList'
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteConfirm() {
        return _deleteConfirm.apply(this, arguments);
      }

      return deleteConfirm;
    }()
  }, {
    key: "changeTab",
    value: function changeTab(val) {
      this.activeTab = val;
    }
  }, {
    key: "handleAudit",
    value: function () {
      var _handleAudit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(index) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = index;
                _context3.next = _context3.t0 === 0 ? 3 : _context3.t0 === 1 ? 9 : 11;
                break;

              case 3:
                _context3.next = 5;
                return this.auditDealer(this.AuditStatus.APPROVED);

              case 5:
                _context3.next = 7;
                return this.getDealerById(Number(this.dealerId));

              case 7:
                this.targetDealer = _context3.sent;
                return _context3.abrupt("break", 11);

              case 9:
                this.denyDialog.show = true;
                return _context3.abrupt("break", 11);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleAudit(_x) {
        return _handleAudit.apply(this, arguments);
      }

      return handleAudit;
    }()
  }, {
    key: "denyConfirm",
    value: function () {
      var _denyConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.auditDealer(this.AuditStatus.REJECT);

              case 2:
                this.denyDialog.show = false;
                _context4.next = 5;
                return this.getDealerById(Number(this.dealerId));

              case 5:
                this.targetDealer = _context4.sent;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function denyConfirm() {
        return _denyConfirm.apply(this, arguments);
      }

      return denyConfirm;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }
  }, {
    key: "editDealerGoods",
    value: function editDealerGoods() {
      this.$router.push({
        name: 'EditDealerGoods',
        params: {
          id: this.dealerId
        }
      });
    }
  }, {
    key: "addManageSchool",
    value: function addManageSchool() {
      this.$router.push({
        name: 'EditDealerSchool',
        params: {
          id: this.dealerId,
          name: this.dealerName
        }
      });
    }
  }, {
    key: "deleteDealerSchoolsConfirm",
    value: function () {
      var _deleteDealerSchoolsConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var updateSchools, schoolIds, result, dealer, typedError;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                updateSchools = this.schools.filter(function (i) {
                  var _this2$targetSchool;

                  return i.id !== ((_this2$targetSchool = _this2.targetSchool) === null || _this2$targetSchool === void 0 ? void 0 : _this2$targetSchool.id);
                });
                schoolIds = updateSchools.map(function (item) {
                  return item.id;
                });
                _context5.prev = 2;
                _context5.next = 5;
                return this.$apollo.query({
                  query: updateDealerSchools,
                  variables: {
                    dealerId: +this.dealerId,
                    schoolIds: schoolIds
                  }
                });

              case 5:
                result = _context5.sent;

                if (!result) {
                  _context5.next = 13;
                  break;
                }

                showNotification({
                  msg: '删除成功',
                  type: SnackType.Info
                });
                _context5.next = 10;
                return this.getDealerById(Number(this.dealerId));

              case 10:
                dealer = _context5.sent;
                this.schools = dealer.schools;
                this.deleteDealerSchoolsDialog.show = false;

              case 13:
                _context5.next = 19;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](2);
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 15]]);
      }));

      function deleteDealerSchoolsConfirm() {
        return _deleteDealerSchoolsConfirm.apply(this, arguments);
      }

      return deleteDealerSchoolsConfirm;
    }()
  }, {
    key: "deleteDealerSchools",
    value: function () {
      var _deleteDealerSchools = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(item) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.deleteDealerSchoolsDialog.show = true;
                this.deleteDealerSchoolsDialog.text = "\u662F\u5426\u5220\u9664\u5B66\u6821\uFF1A".concat(item.name, "?");
                this.targetSchool = item;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteDealerSchools(_x2) {
        return _deleteDealerSchools.apply(this, arguments);
      }

      return deleteDealerSchools;
    }()
  }, {
    key: "deleteDealerGoods",
    value: function () {
      var _deleteDealerGoods = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(item) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.deleteDealerGoodsDialog.show = true;
                this.deleteDealerGoodsDialog.text = "\u662F\u5426\u5220\u9664\u5546\u54C1\uFF1A".concat(item.good.title, "?");
                this.targetGoods = item;

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteDealerGoods(_x3) {
        return _deleteDealerGoods.apply(this, arguments);
      }

      return deleteDealerGoods;
    }()
  }, {
    key: "routeToGoodsDetail",
    value: function routeToGoodsDetail(item) {
      if (this.getRole() !== 'dealer') {
        var _this$targetDealer4;

        this.$router.push({
          name: 'EditGoods',
          params: {
            id: item.goodId,
            dealerId: ((_this$targetDealer4 = this.targetDealer) === null || _this$targetDealer4 === void 0 ? void 0 : _this$targetDealer4.id) + '',
            dealer: JSON.stringify(item),
            isFromDealer: 'yes'
          }
        });
      }
    }
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      this.getGoodsByTitle();
    }
  }, {
    key: "addGoodsCancel",
    value: function addGoodsCancel() {
      this.filter.title = '';
      this.selectedGoods = [];
      this.allGoods = [];
    }
  }, {
    key: "addGoodsConfirm",
    value: function () {
      var _addGoodsConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this$selectedGoods, goods, result, typedError;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.selectedGoods) {
                  _context8.next = 5;
                  break;
                }

                showNotification({
                  msg: '请选择商品',
                  type: SnackType.Error
                });
                return _context8.abrupt("return", false);

              case 5:
                goods = (_this$selectedGoods = this.selectedGoods) === null || _this$selectedGoods === void 0 ? void 0 : _this$selectedGoods.map(function (item) {
                  return {
                    goodId: item.id
                  };
                });
                _context8.prev = 6;
                _context8.next = 9;
                return this.$apollo.mutate({
                  mutation: assignGoodsToDealer,
                  variables: {
                    dealerId: Number(this.dealerId + ''),
                    goods: goods
                  }
                });

              case 9:
                result = _context8.sent;

                if (!result) {
                  _context8.next = 23;
                  break;
                }

                this.addGoods.show = false;
                this.filter.title = '';
                this.selectedGoods = [];
                this.allGoods = [];
                showNotification({
                  msg: '添加成功',
                  type: SnackType.Info
                });
                _context8.next = 18;
                return this.getGoodsOrders();

              case 18:
                _context8.next = 20;
                return this.getDealerById(Number(this.dealerId));

              case 20:
                this.targetDealer = _context8.sent;
                _context8.next = 24;
                break;

              case 23:
                showNotification({
                  msg: '添加失败',
                  type: SnackType.Error
                });

              case 24:
                _context8.next = 30;
                break;

              case 26:
                _context8.prev = 26;
                _context8.t0 = _context8["catch"](6);
                typedError = _context8.t0;
                showErrors(typedError.graphQLErrors);

              case 30:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[6, 26]]);
      }));

      function addGoodsConfirm() {
        return _addGoodsConfirm.apply(this, arguments);
      }

      return addGoodsConfirm;
    }()
  }, {
    key: "getGoodsByTitle",
    value: function () {
      var _getGoodsByTitle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.searchLoading = true;
                _context9.prev = 1;
                _context9.next = 4;
                return this.$apollo.query({
                  query: findGoods,
                  variables: {
                    order: {
                      by: GoodsOrderBy.title,
                      asc: true
                    },
                    paging: {
                      skip: 0,
                      take: 1000
                    },
                    where: {
                      title: this.filter.title
                    }
                  }
                });

              case 4:
                result = _context9.sent;

                if (result) {
                  this.allGoods = result.data.findGoods.goods;
                  this.searchLoading = false;
                }

                _context9.next = 12;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);
                typedError = _context9.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 8]]);
      }));

      function getGoodsByTitle() {
        return _getGoodsByTitle.apply(this, arguments);
      }

      return getGoodsByTitle;
    }()
  }, {
    key: "deleteDealerGoodsConfirm",
    value: function () {
      var _deleteDealerGoodsConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var goodIds, result, _this$targetDealer5, typedError;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                goodIds = [];
                goodIds.push(this.targetGoods.goodId);
                _context10.prev = 2;
                _context10.next = 5;
                return this.$apollo.mutate({
                  mutation: removeGoodsFromDealer,
                  variables: {
                    dealerId: +this.dealerId,
                    goodIds: goodIds
                  }
                });

              case 5:
                result = _context10.sent;

                if (!result) {
                  _context10.next = 15;
                  break;
                }

                showNotification({
                  msg: '删除成功',
                  type: SnackType.Info
                });
                this.deleteDealerGoodsDialog.show = false;
                _context10.next = 11;
                return this.getDealerById(Number(this.dealerId));

              case 11:
                this.targetDealer = _context10.sent;
                this.goods = (_this$targetDealer5 = this.targetDealer) === null || _this$targetDealer5 === void 0 ? void 0 : _this$targetDealer5.goodRelations;
                _context10.next = 15;
                return this.getGoodsOrders();

              case 15:
                _context10.next = 21;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10["catch"](2);
                typedError = _context10.t0;
                showErrors(typedError.graphQLErrors);

              case 21:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 17]]);
      }));

      function deleteDealerGoodsConfirm() {
        return _deleteDealerGoodsConfirm.apply(this, arguments);
      }

      return deleteDealerGoodsConfirm;
    }()
  }, {
    key: "exportHandler",
    value: function exportHandler() {}
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(from, to, next) {
      sessionStorage.setItem('activeTab', this.activeTab + '');
      next();
    }
  }, {
    key: "isPass",
    get: function get() {
      var _this$targetDealer6;

      return ((_this$targetDealer6 = this.targetDealer) === null || _this$targetDealer6 === void 0 ? void 0 : _this$targetDealer6.status) === 'APPROVED';
    }
  }, {
    key: "filterGoods",
    get: function get() {
      var _this$allGoods,
          _this3 = this;

      if (((_this$allGoods = this.allGoods) === null || _this$allGoods === void 0 ? void 0 : _this$allGoods.length) !== 0) {
        var _this$allGoods2;

        return (_this$allGoods2 = this.allGoods) === null || _this$allGoods2 === void 0 ? void 0 : _this$allGoods2.filter(function (item) {
          var _this3$goods;

          return !((_this3$goods = _this3.goods) === null || _this3$goods === void 0 ? void 0 : _this3$goods.some(function (ele) {
            return ele.goodId === item.id;
          }));
        });
      } else {
        return [];
      }
    }
  }]);

  return DealerDetail;
}(mixins(DealerDialog, AuthFilter, DealerOrders));

__decorate([Watch('targetDealer.goodRelations', {
  deep: true,
  immediate: true
})], DealerDetail.prototype, "goodRelationsChange", null);

DealerDetail = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleButton: AppSimpleButton,
    AppTab: AppTab,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppAutoComplete: AppAutoComplete,
    AppFormItem: AppFormItem,
    AppSearchBtn: AppSearchBtn,
    AppTextarea: AppTextarea
  }
})], DealerDetail);
export default DealerDetail;